import { Injectable, Inject, Optional } from "@angular/core";
import { HttpClient, HttpBackend } from "@angular/common/http";
import { ServiceResult } from "../../Infra/ServiceResult";
import { AppHelper } from "../../appHelper/appHelper";
import { SecurityService } from "../security.service";
import { RefreshViewModel } from "../../../Models/refreshViewModel";
import { LocalRepository } from "../../data/repository/local-repository";
import { JwtHelperService } from "@auth0/angular-jwt";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";


export const CLIENT_ID_KEY = 'client_id';

@Injectable({
    providedIn: 'root'
})
export class RefreshTokenService {

    private http: HttpClient;
    private jwtHelper: JwtHelperService;

    constructor(
        private repository: LocalRepository,
       // http: HttpClient,
        handler: HttpBackend) {
        this.http = new HttpClient(handler);//to avoid being intercept
        this.jwtHelper = new JwtHelperService();
    }

    private get UserCurrentId(): string {
        const DECODED_TOKEN = this.jwtHelper.decodeToken(this.repository.getItem("access_token"));
        if (!DECODED_TOKEN || DECODED_TOKEN == undefined || DECODED_TOKEN == null)
            return "";
        return DECODED_TOKEN['userId'];
    }

    /**
     * Refresh token
     */
    public Refresh(): Observable<ServiceResult> {
        const refresh = this.repository.getItem('refresh_token');
        const client_id = this.repository.getItem(CLIENT_ID_KEY);
        const userId = this.UserCurrentId;
        const data = new RefreshViewModel(refresh, userId, client_id);
        const uri = `${AppHelper.SSoApi}account/RefreshToken`;
        return this.http.post<ServiceResult>(uri, data).pipe(
            map((response: any) => {
                let token = response.returnValue ? response.returnValue : new Object();
                if (token.access_token) {
                    this.repository.setItem('access_token', token.access_token);
                    this.repository.setItem('expires_in', token.expires_in);
                    this.repository.setItem('refresh_token', token.refresh_token);
                    return new ServiceResult(true, 'موفقیت آمیز');
                } else {
                    return new ServiceResult(false, response.response);
                }
            }));
    }

}